import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
const getColor = (star: number) => {
  if (star <= 1) {
    return 'var(--one-start-rating)';
  } else if (star <= 2) {
    return 'var(--two-start-rating)';
  } else if (star <= 3) {
    return 'var(--three-start-rating)';
  } else if (star <= 4) {
    return 'var(--four-start-rating)';
  } else if (star <= 5) {
    return 'var(--five-start-rating)';
  }
};
const Rating = ({
  star = 0,
  colorIndicator,
}: {
  star: number | undefined;
  colorIndicator?: boolean;
}) => {
  return (
    <span
      style={{
        border: `2px solid ${
          colorIndicator ? getColor(star) : 'var(--primary-color)'
        }`,
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: '6px',
      }}
    >
      <span
        style={{
          padding: '4px 6px',
          background: `${
            colorIndicator ? getColor(star) : 'var(--primary-color)'
          }`,
          color: 'white',
        }}
      >
        {star}
      </span>
      <FontAwesomeIcon
        icon={faStar}
        style={{
          margin: '0px 6px',
          fontSize: '14px',
          color: 'var(--text-light-color)',
        }}
      />
    </span>
  );
};
export default Rating;
